export default {
    GET_USER_REQUEST: 'USER_DETAIL_GET_USER_REQUEST',
    GET_USER_SUCCESS: 'USER_DETAIL_GET_USER_SUCCESS',

    UPDATE_USER_REQUEST: 'USER_DETAIL_UPDATE_USER_REQUEST',
    UPDATE_USER_SUCCESS: 'USER_DETAIL_UPDATE_USER_SUCCESS',

    UPDATE_PASSWORD_REQUEST: 'USER_DETAIL_UPDATE_PASSWORD_REQUEST',
    UPDATE_PASSWORD_SUCCESS: 'USER_DETAIL_UPDATE_PASSWORD_SUCCESS',

    RESET_PASSWORD_REQUEST: 'USER_DETAIL_RESET_PASSWORD_REQUEST',
    RESET_PASSWORD_SUCCESS: 'USER_DETAIL_RESET_PASSWORD_SUCCESS',

    UPLOAD_AVATAR_REQUEST: 'USER_DETAIL_UPLOAD_AVATAR_REQUEST',
    UPLOAD_AVATAR_SUCCESS: 'USER_DETAIL_UPLOAD_AVATAR_SUCCESS',

    ARCHIVE_USER_REQUEST: 'USER_DETAIL_ARCHIVE_USER_REQUEST',
    ARCHIVE_USER_SUCCESS: 'USER_DETAIL_ARCHIVE_USER_SUCCESS',

    ACTIVATE_USER_REQUEST: 'USER_DETAIL_ACTIVATE_USER_REQUEST',
    ACTIVATE_USER_SUCCESS: 'USER_DETAIL_ACTIVATE_USER_SUCCESS',

    DESTROY_USER_REQUEST: 'USER_DETAIL_DESTROY_USER_REQUEST',
    DESTROY_USER_SUCCESS: 'USER_DETAIL_DESTROY_USER_SUCCESS',
    DISPOSE: 'USER_DETAIL_DISPOSE_STORE',
};
